import React from 'react';
import ProductsTable from '@modules/products/components/products-table/products-table.tsx';

const Products = () => {
  return (
    <div className="w-full h-full">
      <ProductsTable />
    </div>
  );
};

export default Products;
